import { useEffect, useState } from "react";
import { Container, Button, FormControl, Form } from "react-bootstrap";
import ModalVwFrame from "./ModalVwFrame";
import { firestore } from "..";
import AppAdmin from "./ScrapeFirebaseFunction";

function Admin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [inputPass, setInputPass] = useState("");
  const myPass = "alypasha";
  function handleShowModal(value) {
    setShowLogin(value);
  }
  function handleLoginChange(e) {
    setInputPass(e.target.value);
    if (e.target.value === myPass) {
      setIsAdmin(true);
      setShowLogin(false);
    }
  }
  const fetchDataAndStoreInFirestore = async () => {
    try {
      // Make API request using fetch
      const response = await fetch(
        "https://v6.exchangerate-api.com/v6/52008c1868eb33ac219c3d26/latest/USD"
      );

      // Check if the request was successful (status code 200)
      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      // Extract JSON data from the response
      const data = await response.json();

      // Store the data in Firestore
      await firestore.collection("exchangeApi").doc("aly").set(data);

      console.log("Data stored in Firestore successfully!");
    } catch (error) {
      console.error(
        "Error fetching data from API or storing in Firestore:",
        error.message
      );
    }
  };

  useEffect(() => {}, []);
  function auth() {
    return (
      <Form>
        <FormControl
          type="password"
          value={inputPass}
          onChange={handleLoginChange}
        ></FormControl>
        <div
          style={{ overflowX: "hidden", fontFamily: "", margin: "5px" }}
          dir="rtl"
          lang="en"
        ></div>
      </Form>
    );
  }
  return (
    <Container>
      <div
        style={{ overflowX: "hidden", fontFamily: "", margin: "5%" }}
        dir="ltr"
        lang="en"
      >
        {ModalVwFrame(
          true,
          showLogin,
          handleShowModal,
          "Login",
          "Login",
          auth(),
          false
        )}
        <br />
        <div style={{ margin: "5%" }}>
          {isAdmin && (
            <Button onClick={fetchDataAndStoreInFirestore}>
              Fetch currencies
            </Button>
          )}
          {isAdmin && <AppAdmin />}
        </div>
      </div>
    </Container>
  );
}

export default Admin;
